import React from 'react'

const Education = () => {
    return (
        <div>
            <div id="education" class="education">
                <div class="education__title">
                    <h1>EDUCATION</h1>
                </div>
                <div class="education__container">
                    <h2>Nanyang Technological University</h2>
                    <h3>Bachelor of Engineering in Computer Science <span>•</span> May 2024 (Expected)</h3>
                </div>
                <div class="empty"></div>{/* Just to fill up the grid*/}
                <div class="education__container">
                    <h2>Dunman High School</h2>
                    <h3>IP Programme <span>•</span> Dec 2017</h3>
                </div>
            </div>
        </div>
    )
}

export default Education
